// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_leave,
  add_leave,
  update_leave,
  delete_leave,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  leaves: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    type: "School Leave",
    purpose: "",
    from_date: "",
    to_date: "",
    from_time: "",
    to_time: "",
  },
};


// Async Thunks for API Calls
export const fetchleave = createAsyncThunk(
  "leave/fetchleave",
  async (
    { page, page_size, school_id,type, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_leave(
        page,
        page_size,
        school_id,
        type,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createleave = createAsyncThunk(
  "leave/createleave",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_leave(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateleave = createAsyncThunk(
  "leave/updateleave",
  async ({ data, token, signal }, { rejectWithValue }) => {
       console.log("dataLeave",data);
    try {
      const response = await update_leave(data, token, signal);

      
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteleave = createAsyncThunk(
  "leave/deleteleave",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_leave({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const leaveSlice = createSlice({
  name: "leaves",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
       console.log("EDit Data",action.payload)
      // The action should contain all the fields that need to be updated
      const { id, purpose, from_date, to_date,from_time,to_time } = action.payload;
      state.formData = { id,  purpose, from_date, to_date,from_time,to_time  };
    },
    resetFormData(state) {
      state.formData = {
        purpose: "",
        from_date: "",
        to_date: "",
        from_time: "",
        to_time: "",
        type: "School Leave",
      };
    },
    setLeave(state, action) {
      state.leaves = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Classes
      .addCase(fetchleave.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchleave.fulfilled, (state, action) => {
        state.loading = false;
        state.leaves = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchleave.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Class
      .addCase(createleave.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createleave.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createleave.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateleave.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateleave.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateleave.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deleteleave.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteleave.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteleave.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setLeave,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
} = leaveSlice.actions;
export default leaveSlice.reducer;
